import { getFundingEligibilityCategoryValues } from "./funding-eligibility-categories";

/**
 * Maps homepage funding-eligibility category display labels to HubSpot
 * `0-2/industry` internal enum values (WEB-719 / WEB-734).
 */
export const FUNDING_ELIGIBILITY_CATEGORY_TO_HUBSPOT_INDUSTRY: Record<
  string,
  string
> = {
  // Consumer brands
  "Animals & Pet Supplies": "CONSUMER_GOODS",
  "Apparel & Accessories": "APPAREL_FASHION",
  "Baby & Toddler": "CONSUMER_GOODS",
  Beauty: "COSMETICS",
  Electronics: "CONSUMER_ELECTRONICS",
  "Food & Beverages": "FOOD_BEVERAGES",
  Health: "HEALTH_WELLNESS_AND_FITNESS",
  "Home & Garden": "CONSUMER_GOODS",
  "Sporting Goods": "SPORTING_GOODS",
  "Toys & Games": "CONSUMER_GOODS",
  // Other businesses
  "Automotive Services & Dealers": "AUTOMOTIVE",
  "Bars & Restaurants": "RESTAURANTS",
  "Childcare & Education": "EDUCATION_MANAGEMENT",
  "Construction & Trades": "CONSTRUCTION",
  Consulting: "MANAGEMENT_CONSULTING",
  "Gyms, Fitness & Wellness": "HEALTH_WELLNESS_AND_FITNESS",
  "Hotels & Accommodation": "HOSPITALITY",
  "Legal & Accounting": "LEGAL_SERVICES",
  Manufacturing: "MECHANICAL_OR_INDUSTRIAL_ENGINEERING",
  "Marketing & Creative Agencies": "MARKETING_AND_ADVERTISING",
  "Medical & Dental Clinics": "MEDICAL_PRACTICE",
  "Salons & Personal Services": "CONSUMER_SERVICES",
  "Software & IT Services": "INFORMATION_TECHNOLOGY_AND_SERVICES",
  // Legacy labels (pre-WEB-734)
  "Clothing & Apparel": "APPAREL_FASHION",
  "Food & Beverage": "FOOD_BEVERAGES",
  "Health & Beauty": "HEALTH_WELLNESS_AND_FITNESS",
};

export function mapCategoryToHubSpotIndustry(
  category: string
): string | undefined {
  return FUNDING_ELIGIBILITY_CATEGORY_TO_HUBSPOT_INDUSTRY[category];
}

/** All current homepage category values that must have HubSpot mappings. */
export const FUNDING_ELIGIBILITY_HOMEPAGE_CATEGORIES =
  getFundingEligibilityCategoryValues();
